import { cn } from '@/lib/utils';
import { ElementType, InputHTMLAttributes, forwardRef } from 'react';

interface AppInputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: ElementType;
  rightIcon?: ElementType;
  onIconClick?: () => void;
}

const AppInput = forwardRef<HTMLInputElement, AppInputProps>(
  ({ icon: Icon, rightIcon: RightIcon, onIconClick, className, ...args }, ref) => {
    return (
      <div
        className={cn(
          'flex items-center gap-2 rounded-lg border border-coal-300 bg-white px-3 transition-all duration-200 hover:border-coal-400 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/15',
          className
        )}
        onClick={e => {
          const input = e.currentTarget.querySelector('input');
          if (input) input.focus();
        }}
      >
        {Icon && (
          <button type="button" className="flex-shrink-0">
            <Icon width={18} height={18} className="text-coal-400" />
          </button>
        )}
        <input
          ref={ref}
          className="min-h-9 w-full flex-1 bg-transparent text-sm text-coal-900 placeholder:text-coal-400 focus:outline-none"
          type="text"
          {...args}
        />
        {RightIcon && (
          <button type="button" onClick={onIconClick} className="flex-shrink-0">
            <RightIcon width={18} height={18} className="text-coal-400 hover:text-coal-600" />
          </button>
        )}
      </div>
    );
  }
);

AppInput.displayName = 'AppInput';

export default AppInput;
